<template>
  <div class="container p-1 my-4 align-items-center">
    <div class="aguarde-container text-center" v-if="loading">
      <div class="spinner-border" role="status"></div>
      <br />
      <span>Aguarde...</span>
    </div>
    <div class="flex-column h-100 text-center p-4 d-flex" v-if="detalhesPagamento && !loading">
      <div>
        <div class="px-5 pb-4">
          Você pode utilizar o saldo da sua carteira + cashback para pagar o
          valor abaixo.
        </div>
        <div v-if="mensagemErro" class="card my-2 badge-danger text-center p-3 text-uppercase">
          {{ mensagemErro.title }}
        </div>
        <div v-if="mensagemSucesso" class="card my-2 badge-success text-center p-3 text-uppercase">
          {{ mensagemSucesso }}
        </div>
        <div @click="copiarCodigo" v-if="
          detalhesPagamento &&
          detalhesPagamento.boletoDTO &&
          detalhesPagamento.status == 'REGISTRO_PAGAMENTO_PENDENTE'
        " class="card p-2 mt-2">
          <div v-if="copiaSucesso" class="sucesso">
            código do boleto copiado
          </div>
          <strong class="border-bottom pb-2 mb-3">copiar linha digitável</strong>
          <small>
            {{ mascaraBoleto(detalhesPagamento.boletoDTO.linhaDigitavel) }}
          </small>
          <input style="opacity: 0; height: 0" id="codigoBarraBoleto"
            v-model="detalhesPagamento.boletoDTO.linhaDigitavel" />
        </div>

        <div class="card p-2 mt-3">
          <strong class="border-bottom pb-2 mb-3">Dados de pagamento</strong>
          <div class="d-flex justify-content-between">
            <span>Código:</span><strong>{{
                formatCodigoPagamento(detalhesPagamento.codigoPagamento)
            }}</strong>
          </div>

          <div class="d-flex justify-content-between">
            <span>Situação:</span>
            <strong>
              <span v-if="detalhesPagamento.status == 'PAGAMENTO_REALIZADO'" class="badge badge-success">Paga
              </span>
              <span v-if="detalhesPagamento.status == 'CANCELADO'" class="badge badge-danger">Cancelada
              </span>
              <span v-if="detalhesPagamento.status == 'ESTORNADO'" class="badge badge-warning">Estornada
              </span>
              <span v-if="detalhesPagamento.status == 'ESTORNO_SOLICITADO'" class="badge badge-warning">Estorno
                Solicitado
              </span>
              <span v-if="
              detalhesPagamento.status == 'REGISTRO_PAGAMENTO_PENDENTE'"
                v-bind:class="formatClassePagamento(detalhesPagamento.dataLimite)">{{
                    formatStatusPagamento(detalhesPagamento.dataLimite)
                }} <br />
              </span>
            </strong>
          </div>
          <div class="d-flex justify-content-between">
            <span>Vencimento:</span><strong>{{ formatDate(detalhesPagamento.dataLimite) }}</strong>
          </div>
          <div class="d-flex justify-content-between">
            <span>Valor:</span><strong>R$ {{ formatPrice(detalhesPagamento.valor) }}</strong>
          </div>
        </div>
        <div class="card aviso px-3 d-block py-2 border-0" v-if="detalhesPagamento.boletoDTO">
          <span>Após o pagamento, o boleto poderá levar até</span>
          <strong>&nbsp;2 dias úteis para ser compensado.</strong>
        </div>
      </div>

      <!-- <button
        class="btn btn-secondary mr-lg-auto mt-4 px-lg-5 py-2"
        @click="goToStep('pedido')"
      >
        EXMPLO
      </button> -->
      <div class="mt-3 mb-5 px-3 col-12 d-flex flex-column flex-lg-row justify-content-between">

        <button type="button" v-if="
          detalhesPagamento &&
          detalhesPagamento.status == 'REGISTRO_PAGAMENTO_PENDENTE' &&
          checkPagamentoAtual
        " @click="pagar" class="btn btn_color_system px-5 mt-4 py-2">
          Pagar com saldo da carteira
        </button>

        <button type="button" v-if="pagamentoPix &&
          detalhesPagamento &&
          detalhesPagamento.status == 'REGISTRO_PAGAMENTO_PENDENTE' &&
          checkPagamentoAtual
        " @click="pagarParcelaPix" class="btn btn_color_system px-5 mt-4 py-2">
          Pagar com PIX
        </button>
        <a target="_blank" v-if="
          detalhesPagamento &&
          detalhesPagamento.boletoDTO &&
          detalhesPagamento.status == 'REGISTRO_PAGAMENTO_PENDENTE'
        " :href="detalhesPagamento.boletoDTO.urlPdfDownload" class="btn btn_color_system px-5 mt-4 py-2">Baixar
          boleto</a>

        <button type="button" @click="$router.go(-1)" class="btn btn_color_system px-5 mt-4 py-2">
          Voltar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { APIService } from "../../APIService";
const apiService = new APIService();

export default {
  name: "DetalhesParcela",
  props: [],
  data() {
    return {
      loading: false,
      recorrenciaId: this.$route.params.recorrenciaId,
      pagamentoId: this.$route.params.pagamentoId,
      detalhesPagamento: null,
      copiaSucesso: false,
      mensagemErro: null,
      mensagemSucesso: null,
      pagamentoPix: false,
      checkPagamentoAtual: false
    };
  },
  computed: {},
  created() {
    this.obterParcela();
    this.obterFuncionalidades();
    this.verificaParcelaPagamento();
  },
  methods: {
    voltar() {
      history.back();
    },
    pagar() {
      this.loading = true;
      this.mensagemErro = null;
      this.mensagemSucesso = null;

      apiService
        .pagarParcela(this.detalhesPagamento)
        .then((res) => {
          console.log(res);
          this.loading = false;
          this.mensagemSucesso = "Pagamento realizado com sucesso.";
          this.obterParcela();
        })
        .catch((error) => {
          this.loading = false;
          this.mensagemErro = error.response.data;
        });
    },
    pagarParcelaPix() {
      this.loading = true;
      this.mensagemErro = null;
      this.mensagemSucesso = null;

      apiService
        .pagarParcelaPix(this.detalhesPagamento)
        .then((res) => {
          this.loading = false;
          this.mensagemSucesso = "Pix criado com sucesso.";
          this.$router.push(`/pagamento-pix/${res.result.id}`);
        })
        .catch((error) => {
          this.loading = false;
          this.mensagemErro = error.response.data?.result
            ? error.response.data.result
            : "Ocorreu um problema ao processar o pagamento, tente novamente.";
        });
    },
    obterParcela() {
      this.loading = true;
      apiService
        .obterParcela(this.recorrenciaId, this.pagamentoId)
        .then((res) => {
          this.detalhesPagamento = res;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    obterFuncionalidades() {
      apiService
        .getFuncionalidade(window.APP_ORIGIN)
        .then((res) => {
          this.pagamentoPix =
            res.filter((e) => {
              return "PAGAMENTO_PIX" == e.funcionalidade;
            })[0]?.valor == true;
        })
        .catch(() => {
          this.pagamentoPix = false;
        });
    },
    formatCodigoPagamento(codigoReferencia) {
      return codigoReferencia == null
        ? ""
        : codigoReferencia.toUpperCase().substring(0, 8);
    },
    formatPrice(value) {
      if (value) {
        let val = (value / 1).toFixed(2).replace(".", ",");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    formatDate(date) {
      return this.$moment(date).format("DD/MM/YYYY");
    },
    copiarCodigo() {
      document.getElementById("codigoBarraBoleto").select();
      document.execCommand("copy");
      this.copiaSucesso = true;
      setTimeout(() => {
        this.copiaSucesso = false;
      }, 800);
    },
    mascaraBoleto(data) {
      const numeroBoleto = [
        data.slice(0, 5),
        ".",
        data.slice(5, 10),
        " ",
        data.slice(10, 15),
        ".",
        data.slice(15, 21),
        " ",
        data.slice(21, 26),
        ".",
        data.slice(26, 32),
        " ",
        data.slice(32, 33),
        " ",
        data.slice(33),
      ];
      return numeroBoleto.join("");
    },
    formatClassePagamento(date) {
      return this.$moment(date).isBefore(this.$moment(new Date())) ? 'badge badge-danger' : 'badge badge-primary'
    },
    formatStatusPagamento(date) {
      return this.$moment(date).isBefore(this.$moment(new Date())) ? 'Atrasada' : 'Em Aberta';
    },
    verificaParcelaPagamento() {
      this.loading = true;
      apiService
        .verificaParcelaPagamento(this.recorrenciaId, this.pagamentoId)
        .then((res) => {
          this.checkPagamentoAtual = res;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style  scoped lang="scss">
.color-system-principal {
  color: var(--cor-principal) !important;
}

.color-system-background {
  background-color: var(--cor-principal) !important;
  color: white;
}

.card {
  border-radius: 10px;
  position: relative;

  &.aviso {
    background-color: #dfdfdf;
  }

  .sucesso {
    background-color: #a0d405;
    color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    width: 100%;
    text-transform: uppercase;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>